import axiosInstance from 'api/axiosInstance';
import { RegisteredPlates } from 'containers/pages/CANpark/types/registeredPlates';

export const addRegisteredPlates = async (
	plates: RegisteredPlates[],
): Promise<void> => {
	try {
		const API_URL = `/api2.0/registeredPlates/addRegisteredPlates`;

		// ✅ Convert Date objects to ISO 8601 before sending
		type FormattedPlates = Omit<
			RegisteredPlates,
			'validFrom' | 'validUntil'
		> & { validFrom: string; validUntil: string };

		const formattedPlates: FormattedPlates[] = plates.map((plate) => ({
			...plate,
			validFrom: plate.validFrom.toISOString(),
			validUntil: plate.validUntil.toISOString(),
		}));

		await axiosInstance.post(API_URL, formattedPlates, {
			headers: { 'Content-Type': 'application/json' },
		});

		console.log('✅ Registered plates added successfully.');
	} catch (error) {
		console.error('❌ Error adding registered plates:', error);
		throw error;
	}
};
